import { constructs } from "../api/contructs";
import { CreateGenericChildReducer } from "./CreateGenericChildReducer";

export const DataSourceRevisionsReducer = CreateGenericChildReducer(constructs["data-source-revision"]);
